/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const SearchDefaultIcon = React.forwardRef<
  HTMLDivElement,
  BaseIconProps
>(({size = 16, ...props}, ref) => {
  return (
    <BaseIcon {...props} size={size} ref={ref}>
      <svg
        data-wf-icon="SearchDefaultIcon"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.56338 4C5.59538 4 4 5.59538 4 7.56338C4 9.53138 5.59538 11.1268 7.56338 11.1268C9.53138 11.1268 11.1268 9.53138 11.1268 7.56338C11.1268 5.59538 9.53138 4 7.56338 4ZM3 7.56338C3 5.04309 5.04309 3 7.56338 3C10.0837 3 12.1268 5.04309 12.1268 7.56338C12.1268 8.64339 11.7516 9.63578 11.1244 10.4173L13.8536 13.1464L13.1464 13.8536L10.4173 11.1244C9.63578 11.7516 8.64339 12.1268 7.56338 12.1268C5.04309 12.1268 3 10.0837 3 7.56338Z"
            fill="currentColor"
          />
        </g>
      </svg>
    </BaseIcon>
  );
}) as IconComponent;

SearchDefaultIcon.tags = [
  'magnifying glass',
  'look',
  'quick',
  'find',
  'explore',
  'inspect',
  'discover',
];

SearchDefaultIcon.category = 'General Icons';

SearchDefaultIcon.iconSize = 16;
